import React from 'react';

import Layout from '~/layouts/header-footer';

import './privacy-policy.scss';

import SEO from '~/components/seo';

class PrivacyPolicyPage extends React.Component {
  render = () => pug`
    Layout
      SEO(title="Privacy Policy")
      .privacy-policy
        .page__intro
          h1 Privacy Policy
          h5 This website collects the following personal data for the purposes specified below.
        .centered-container
          .privacy-policy__content
            .privacy-policy__entry
              h3 Contact form and contacting the user
              h5 Data collected:
              ul
                li Email address
                li First & Last Name
            .privacy-policy__entry
              h3 Hosting and backend infrastructure on Netlify
              h5 Data collected:
              ul
                li Email address
                li First & Last Name
                li Data communicated while using the service as specified in the&nbsp;
                  a(href="https://www.netlify.com/privacy/", target="_blank", rel="noopener") privacy policy of the service
            .privacy-policy__entry
              h3 Newsletter on Mailchimp
              h5 Data collected:
              ul
                li Email address
                li Data communicated while using the service as specified in the&nbsp;
                  a(href="https://mailchimp.com/legal/privacy/", target="_blank", rel="noopener") privacy policy of the service
            .privacy-policy__entry
              h3 Database infrastructure on Firebase
              h5 Data collected:
              ul
                li Anonymous Usage Data
            .privacy-policy__entry
              h3 Contact information
              h5 Owner and Data Controller
              p Stefano Contiero
                br
                | via Gamba 11
                br
                | 36061 Bassano del Grappa (VI), Italy
              p Contact email: hi@stefanocontiero.com
          .privacy-policy__entry
            h6 Last update: 12 August 2019
  `;
}

export default PrivacyPolicyPage;
